import styled from 'styled-components';

export const PlayerWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background: rgba(0, 0, 0, 0.5);
`;
